import { Task, TaskStatus } from '@interfaces/task/task';

export function mapAlarmRowsToTasks(rows: any[]): Task[] {
  return rows.map((row) => {
    const statusStr = String(row.status || '').toLowerCase();

    return {
      departments: row?.data?.location?.department
        ? [row.data.location.department]
        : undefined,

      type: 'ALARM_NOTIFICATION',
      sequence: row.sequence,

      data: {
        filterDepts: row.data.filterDepts?.map((fd: any) => ({
          unit: fd.unit,
          department: fd.department,
        })),
        type: row.data.alarm,
        icon: row.data.icon,
        description: row.data.description,
        location: row.data.location?.name ?? row.data.location,
        startTime: row.data.startTime as unknown as string,
        title: row.data.alarm,
        additionalDetails: row.data.additionalInfo,
        closeTs: row.data.closeTs as unknown as string,
      },

      isTask: false,
      isHighlighted: false,
      isRead: false,

      key: row.sequence,
      status:
        statusStr === 'initiated'
          ? TaskStatus.INITIATED
          : statusStr === 'active'
            ? TaskStatus.ACTIVE
            : TaskStatus.CLOSED,
    } as Task;
  });
}
